import axios from 'axios'
// import storage from 'store'
import qs from 'qs'
// import router from '@/router'
// import store from '@/store'
import notification from 'ant-design-vue/es/notification'
// import { base64Decode } from '../crypto'
// import { ACCESS_TOKEN } from '@/store/mutation-types'

//1.创建 axios 实例
const instance = axios.create({
  // 接口地址
  // baseURL: process.env.VUE_APP_API_BASE_URL+'/restfulApi',
  baseURL: '/restfulApi',
  // 请求超时时间
  timeout: 20000
})

// 2.请求拦截
instance.interceptors.request.use(
  config => {
    const custom = config.custom
    // 如果配置了custom.auth = true
    if (custom && custom.auth){
		
		const token = getCookie("TOKEN");
      if (token) {
        config.headers['Authorization'] = token
      }
    }
    // 如果配置了custom.form = true
    if (custom && custom.form){
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      config.transformRequest = [function (data) {
        return qs.stringify(data)
      }]
    }
    return config
  }
);
function getCookie(name) {
  const cookies = document.cookie.split(";"); // 将cookie字符串分割成数组

  for (let i = 0; i < cookies.length; i++) {
	const cookie = cookies[i].trim();

	// 判断cookie的key是否与指定的name相等
	if (cookie.startsWith(name + "=")) {
	  // 如果相等，返回去除了cookie名之后的值
	  return cookie.substring(name.length + 1, cookie.length);
	}
  }

  // 如果没有找到对应的cookie，则返回空字符串或者null
  return "";
}

// 3.响应拦截
instance.interceptors.response.use(
  res => {
	  return res.data
    // if (res.success) {
    //   return res.data
    // }
    // if (res.config.responseType === 'blob') {
    //   return res
    // }
    // if (res.data.code == 40104) {
    //   notification.error({
    //     message: 'Unauthorized',
    //     description: '请求授权无效(授权信息过期)'
    //   })
    //   const token = storage.get(ACCESS_TOKEN)
    //   if (token) {
    //     store.dispatch('Logout').then(() => {
    //       setTimeout(() => {
    //         window.location.reload()
    //       }, 1500)
    //     })
    //   }
    // } else if (res.data.code === 40107) {
    //   router.push({
    //     path: '/signin',
    //     query: {redirect: router.history.current.fullPath}
    //   })
    // }
    // return Promise.reject(res.data) 
  },
  error => {
    if(error && error.response){
      const status = error.response.status
      switch (status) {
        case 404:
          notification.error({
            message: 'Not Found',
            description: '请求接口不存在'
          })
          break
        default:
          notification.error({
            message: 'Request Error',
            description: '请求失败'
          })
      }
    } else {
      if (JSON.stringify(error).includes('timeout')) {
        notification.error({
          message: 'Timeout',
          description: '服务器响应超时，请刷新页面！'
        })
      }
      notification.error({
        message: 'Error',
        description: '服务器连接失败！'
      })
    }
    return Promise.reject(error.response.data)
  }
)

// 4.导出实例
export default instance